import { Route, Routes } from "react-router-dom"
import { useEffect } from "react"
import { useLocation, useSearchParams } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { setAppData, clearAppData } from "../../Store/smileWhiteSlice"
import { postLogDetails } from "../../Services/APIs/appDetails"
import LandingPage from "./LandingPage/index"
import FullScan from "./Scan/fullScan"

const SmileWhite = () => {
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const dispatch = useDispatch();
    const currentAppData = useSelector(state => state.smileWhite);


    useEffect(() => {
        // Get query parameters using useSearchParams
        const tempParam = searchParams.get('uid');
        const tokenParam = searchParams.get('token');
        const utmParam = searchParams.get('UTM');
                
        if (tempParam || tokenParam || utmParam) {
            const newData = {
                uid: tempParam || null,
                token: tokenParam || null,
                utm: utmParam || null,
                company: "smilewhite"
            };
            
            dispatch(setAppData(newData));
        } else if (!currentAppData.uid) {
            dispatch(clearAppData());
        }
    }, [searchParams, dispatch, currentAppData.uid]);

    return (
        <div className="h-full">
            <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/scan" element={<FullScan />} />
                <Route path="/*" element={<LandingPage />} />
            </Routes>
        </div>
    )
}

export default SmileWhite